import React from 'react';

const EditAssigmentSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="4" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M10.9569 4.99985C11.7379 4.2188 13.0042 4.2188 13.7853 4.99985L15.1995 6.41406C15.9806 7.19511 15.9806 8.46144 15.1995 9.24249L10.0161 14.4259C9.76378 14.6782 9.44854 14.8584 9.10309 14.9479L5.55061 15.8674C5.20768 15.9562 4.84338 15.8569 4.5929 15.6065C4.34243 15.356 4.24315 14.9917 4.33192 14.6487L5.2515 11.0963C5.34092 10.7508 5.52114 10.4356 5.77347 10.1832L10.9569 4.99985ZM13.7853 7.82828L12.3711 6.41406L7.18768 11.5975L6.69375 13.5056L8.60189 13.0117L13.7853 7.82828Z"
            fill="#969FA8" />
    </svg>

  );
};

export default EditAssigmentSVG;
